import { render, staticRenderFns } from "./BlockType11List.vue?vue&type=template&id=a3902c3e&scoped=true"
import script from "./BlockType11List.vue?vue&type=script&lang=ts"
export * from "./BlockType11List.vue?vue&type=script&lang=ts"
import style0 from "./BlockType11List.vue?vue&type=style&index=0&id=a3902c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3902c3e",
  null
  
)

export default component.exports